export default {
  body: `"Rubik", sans-serif`,
  heading: `"GT-Eesti-Display-Regular", sans-serif`,
}
